module.exports = {"id":"209569","name":"Hussain Al Moqahwi","rating":"71","photo":"./data/images/photos/0/209569.png","club":{"name":"Al Ahli","logo":"./data/images/clubs/AlAhli.png"},"positions":["MOC","MC","MDC","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/HussainAlMoqahwi0.json
// module id = 1759
// module chunks = 0